import { useEffect, useState } from 'react';
import { storesApi } from '@/api';
import type { StoreResponse } from '@/types/store';
import { showApiError } from '@/utils/apiError';

export function useActiveStores() {
  const [stores, setStores] = useState<StoreResponse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    storesApi
      .list({ size: 100, activeOnly: true })
      .then((res) => {
        if (!cancelled) setStores(res.content);
      })
      .catch((err) => {
        if (!cancelled) showApiError(err, 'Failed to load stores');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { stores, loading };
}
